import { FC, useState } from 'react';
import { Icon } from 'common-components';
import { Checkbox } from '@mui/material';
import classNames from 'classnames';
import { CardTypes } from './cardTypes';
import Theme from '../theme';
import styles from './card.module.scss';

const Card: FC<CardTypes> = (props: CardTypes) => {
    const {
        header,
        description,
        optionsList,
        image,
        onSelect,
        select,
        showCheckbox = false,
        wrapperRef,
        isDisabled,
        disableText,
        info
    } = props;
    const [hover, setHover] = useState(false);

    return (
        <Theme>
            <div
                ref={wrapperRef}
                className={classNames(styles.card)}
                style={{ '--backgroundColor': select ? '#F6F3FC' : '#fff' } as any}
                onClick={() => onSelect?.()}
            >
                <div
                    className={classNames(styles.left, {
                        [styles.disabled]: isDisabled
                    })}
                >
                    {showCheckbox && (
                        <Checkbox
                            disabled={isDisabled}
                            checked={select}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSelect?.(e.target.checked)}
                        />
                    )}
                    <div className={styles['left-title']}>
                        <div className={styles['title-wrapper']}>
                            <div className={styles.title}>{header.title}</div>
                            {header.icons && header.icons.length > 0 && (
                                <div className={styles['icons-wrapper']}>
                                    {header.icons.map((icon, index) => (
                                        <Icon key={index} className={styles.icon} name={icon} />
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className={styles.tags}>
                            {optionsList.map((option, index) => {
                                return (
                                    <div className={styles.tag} key={index}>
                                        <Icon className={styles.icon} name={option.icon} />
                                        <div className={styles['main-text']}>{option.mainText}</div>
                                        <div className={styles['secondary-text']}>{option.secondaryText}</div>
                                        {index < optionsList.length - 1 && <hr />}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div
                    className={classNames(styles.right, {
                        [styles.disabled]: isDisabled
                    })}
                >
                    {description && (
                        <div
                            onMouseEnter={() => {
                                setHover(true);
                            }}
                            onMouseLeave={() => {
                                setHover(false);
                            }}
                            className={styles}
                        >
                            <Icon name="grayInfoIcon" className={styles.icon} />
                        </div>
                    )}
                    {hover && <div>{description}</div>}
                    <img className={styles.image} src={image} alt="card" />
                </div>
                {isDisabled && (
                    <div className={styles['disable-tag']}>
                        <div className={styles.text}>{disableText}</div>
                    </div>
                )}
                {info && (
                    <div className={styles['info-tag']}>
                        <Icon name="warningYellow" className={styles.icon} />
                        <div className={styles.text}>{info}</div>
                    </div>
                )}
            </div>
        </Theme>
    );
};

export default Card;
